export const Fragment = `
    uniform float uAlpha; 

    void main(){
        gl_FragColor = vec4(0.933, 0.933, 0.933, uAlpha);
    }
`
